import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';

@Injectable()

export class TokenInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<any>, next: HttpHandler) {

        let token: any = localStorage.getItem('authKey');
        if (token && token !== undefined && token !== null) {
            request = this.addtoken(request, token);
            return next.handle(request);
        } else {
            return next.handle(request);

        }
    }

    private addtoken(request: HttpRequest<any>, token: any) {

        return request.clone({
            setHeaders: { 'authKey': token }
        });
    }
}
